import { Record, List } from 'immutable';

const defaultValues = {
  id: null,
  opcoId: null,
  country: '',
  syscoCustomerId: null,
  firstName: '',
  lastName: '',
  emailAddress: '',
  role: new List(),
  privileges: new List(),
  password: '',
  invitationKey: 'key-123456',
  loginCount: 0,
  timezoneOffset: 0,
  locale: 'en_US',
  source: 'unknown',
  agreedToLegal: true,
  hierarchical: false,
  internal: false,
  syscoFederatedId: null,
  mfaAlertedFlag: null,
};

export default class User extends Record(defaultValues, User) {
  constructor(values) {
    super({
      ...values,
      opcoId: values && values.opcoId ? values.opcoId : defaultValues.opcoId,
      syscoCustomerId: values && values.syscoCustomerId
                              ? values.syscoCustomerId
                              : defaultValues.syscoCustomerId,
    });
  }

  getFullName(exact = false) {
    const firstName = this.get('firstName') || '';
    const lastName = this.get('lastName') || '';
    const fullName = `${firstName} ${lastName}`.trim();

    return exact ? fullName : (fullName || 'Friend');
  }

  getFirstName(exact = false) {
    const firstName = this.get('firstName') || '';
    return exact ? firstName : (firstName || 'Friend');
  }

  getEmailAddress() {
    return `${ this.get('emailAddress').toLowerCase() }`;
  }

  getSyscoId() {
    return `${ this.get('opcoId') }-${ this.get('syscoCustomerId') }`;
  }
}
